import { z } from 'zod';
/** Roles a creator can have on an issue, in the order the UI lists them. */
export const creatorRoles = [
    'writer',
    'artist',
    'penciller',
    'inker',
    'illustrator',
    'colorist',
    'letterer',
    'cover',
    'translator',
    'editor',
];
export const creatorRoleSchema = z.enum(creatorRoles);
export const creditSchema = z.object({
    name: z.string(),
    role: creatorRoleSchema,
});
/**
 * Sources name roles freely ("Writer", "Script", "Cover Artist", the DNB's
 * relator codes "aut", "art", "ill"). This maps them onto the fixed list.
 * Roles outside it (editor in chief, designer, ...) return null and are not
 * stored.
 */
const roleAliases = {
    writer: 'writer',
    script: 'writer',
    story: 'writer',
    plot: 'writer',
    author: 'writer',
    aut: 'writer',
    artist: 'artist',
    art: 'artist',
    penciller: 'penciller',
    penciler: 'penciller',
    pencils: 'penciller',
    inker: 'inker',
    inks: 'inker',
    illustrator: 'illustrator',
    ill: 'illustrator',
    colorist: 'colorist',
    colourist: 'colorist',
    colors: 'colorist',
    clr: 'colorist',
    letterer: 'letterer',
    letters: 'letterer',
    cover: 'cover',
    'cover artist': 'cover',
    translator: 'translator',
    translation: 'translator',
    trl: 'translator',
    editor: 'editor',
    edt: 'editor',
};
export function normalizeCreatorRole(raw) {
    return roleAliases[raw.trim().toLowerCase()] ?? null;
}
/**
 * Role order first (writer before artist), then names alphabetically. Volumes
 * of one series credit the same person differently (the DNB calls the artist
 * "illustrator" on some records), so an illustrator credit is dropped for
 * anyone already listed as artist.
 */
export function sortCredits(credits) {
    const known = credits.filter((credit) => creatorRoleSchema.safeParse(credit.role).success);
    const artists = new Set(known.filter((c) => c.role === 'artist').map((c) => c.name));
    return known
        .filter((credit) => !(credit.role === 'illustrator' && artists.has(credit.name)))
        .sort((a, b) => creatorRoles.indexOf(a.role) - creatorRoles.indexOf(b.role) ||
        a.name.localeCompare(b.name, 'de'));
}
//# sourceMappingURL=creators.js.map